/** @format */

export {
    ApplicationContext,
    type ApplicationContextProps,
    type BlackoutContextProps,
    type LegalLinksContextProps,
    type ModalOptions,
    type ModalContextProps,
    type AdditionalHeaderContextProps,
    ScrollLock,
} from './context/application';

export { Blackout } from './components/blackout';
export { Modal, ModalSize, ModalVariant } from './components/modal';
export { convertRemToPixels } from './helpers/css';

export { useFocusTrap } from './hooks/use-focus-trap';
export { useMediaQuery } from './hooks/use-media-query';
export { withNamedTryCatch } from './helpers/try-catch';

export { Milliseconds } from './config/constants';
export {
    type PromoCode,
    type WithMountCallback,
    type EmotionDynamicElement,
} from './config/types';

export { default as apm } from './helpers/elastic-apm-rum';
export {
    MediaQuery,
    smallMobile,
    smallTablet,
    mobile,
    largeTablet,
    largeDesktop,
    desktop,
} from './helpers/media-queries';

export { hasPathNameChanged } from './helpers/path';
export { flattenObject } from './helpers/object';
export {
    safeObjectFit,
    cssRepeat,
    type MediaQueryColumns,
    generateGridTemplateColumns,
    focusOutline,
} from './helpers/styles';

export { default as logger } from './helpers/logger';
export { retry } from './helpers/retry';

export { hasValue } from './helpers/type-checking';
export {
    getCsrfToken,
    getCsrfTokenValue,
    rejectIfInvalidCSRFResponse,
    isInvalidCSRFResponse,
} from './helpers/csrf';

export { globalStyles } from './helpers/global-styles';

export {
    sendMetrics,
    startMetrics,
    checkoutCreateAttemptedMetric,
    checkoutCreateFailedMetric,
    checkoutFinalizeAttemptedMetric,
    checkoutFinalizeFailedMetric,
    paymentGatewayFailedMetric,
    paymentGatewayAttemptedMetric,
} from './helpers/metrics';

export { NamedException } from './helpers/named-exception';
